import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["getHeaderTitle", "actionMetadata", "actionId"];
import PropTypes from 'prop-types';
import AdsAudienceMembershipActionMetadata from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionMetadata';
import AutomationBuilderCard from 'automation-ui-flow-core/canvas/AutomationBuilderCard';
import AdsAudienceMembershipActionSummary from 'automation-ui-action-features/actions/ads-audience-membership/AdsAudienceMembershipActionSummary';
import { jsx as _jsx } from "react/jsx-runtime";
function AdsAudienceMembershipActionCard(_ref) {
  let {
      getHeaderTitle,
      actionMetadata,
      actionId
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(AutomationBuilderCard, Object.assign({}, restProps, {
    headerTitle: getHeaderTitle({
      actionId
    }),
    content: /*#__PURE__*/_jsx(AdsAudienceMembershipActionSummary, {
      actionMetadata: actionMetadata
    })
  }));
}
AdsAudienceMembershipActionCard.propTypes = {
  getHeaderTitle: PropTypes.func.isRequired,
  actionMetadata: PropTypes.instanceOf(AdsAudienceMembershipActionMetadata).isRequired,
  actionId: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
};
export default AdsAudienceMembershipActionCard;